// Session Manager to handle token expiration globally
let sessionExpirationCallback = null;

export const setSessionExpirationCallback = (callback) => {
  sessionExpirationCallback = callback;
};

export const triggerSessionExpiration = () => {
  if (sessionExpirationCallback) {
    sessionExpirationCallback();
  }
};

// Override fetch to intercept 401 responses
const originalFetch = window.fetch;
window.fetch = function (...args) {
  return originalFetch.apply(this, args).then((response) => {
    // Clone the response so we can read it without consuming it
    const clonedResponse = response.clone();

    // Check if it's a 401 status
    if (response.status === 401) {
      // Trigger session expiration modal
      triggerSessionExpiration();
    }

    return response;
  });
};

// Also intercept JSON parsing to catch 401 in response body
export const handleApiResponse = (response) => {
  if (response.status === 401 || response.status >= 401) {
    triggerSessionExpiration();
  }
  return response;
};
